<template>
  <div>
    <div class="fe-spacing-vertical fe-spacing-horizontal">
      <QnATitle class="fe-mb-m" />

      <div v-if="!questionsList?.length">
        <EmptyQnA
          class="fe-mb-l"
          text="No questions available for the product."
        />

        <AskQuestionCta />
      </div>

      <div v-else>
        <AllQnAList
          v-for="question in questionsList"
          :qna="question"
          :key="question.id"
        />

        <div
          v-if="showAllQuestionCta"
          class="fe-border-t fe-border-primary-grey-40 fe-border-solid"
        >
          <JdsButton
            variant="tertiary"
            :fullWidth="true"
            @click="openQnAListModal"
          >
            View all
          </JdsButton>
        </div>
      </div>
    </div>

    <div v-if="questionsList?.length">
      <div class="fe-h-xs fe-bg-primary-grey-20 fe-mb-m"></div>
      <div class="fe-spacing-horizontal fe-flex fe-flex-col">
        <div
          class="fe-mb-xs fe-mx-auto fe-text-body-xs fe-text-primary-grey-80"
        >
          Did your question got answered?
        </div>

        <AskQuestionCta />
      </div>
    </div>
  </div>
</template>

<script>
  import AskQuestionCta from "@/components/QuestionAndAnswer/AskQuestionCta/AskQuestionCta.vue"
  import EmptyQnA from "@/components/QuestionAndAnswer/EmptyQnA/EmptyQnA.vue"
  import QnATitle from "@/components/QuestionAndAnswer/QnATitle/QnATitle.vue"
  import AllQnAList from "@/components/QuestionAndAnswer/AllQnAList/AllQnAList.vue"
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import { modalMixin } from "@/mixins/modalMixin"
  import QnAListModal from "@/components/QuestionAndAnswer/QnAListModal/QnAListModal.vue"
  // import AskQuestionDialog from "@/components/QuestionAndAnswer/AskQuestionDialog/AskQuestionDialog.vue"

  export default {
    name: "LayoutOneMobile",
    components: {
      QnATitle,
      EmptyQnA,
      AskQuestionCta,
      AllQnAList,
      JdsButton,
    },
    mixins: [modalMixin],
    inject: ["globalState"],
    computed: {
      questionsList() {
        return this.globalState.qnA.slice(0, 3)
      },
      showAllQuestionCta() {
        return this.questionsList?.length > 2
      },
    },
    methods: {
      openQnAListModal() {
        this.openDialog(QnAListModal)
      },
    },
  }
</script>
